export enum FormMultiSelectEvent {
  ASYNC_SELECTED_OPTION_LOADED = 'TableFilterEvent:ASYNC_SELECTED_OPTION_LOADED'
}
